import styled from "@emotion/styled"
import { PButtonPure, PText } from "@porsche-design-system/components-react"
import { colorContrastLow, spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import type { CustomerFeedbackView } from "@slfinrtl/ui-bff-routes"
import { useCallback } from "react"
import { FormattedMessage } from "react-intl"
import { useModal } from "src/context/modal/useModal"
import { CustomerFeedbackItem } from "./CustomerFeedbackItem"
import { CustomerFeedbackModal } from "./CustomerFeedbackModal"
import type { CustomerFeedbackModalProps } from "./CustomerFeedbackModal"
import { customerFeedbackMessages } from "./customerFeedback.messages"

interface CustomerFeedbackProps {
	view: CustomerFeedbackView
}

export const CustomerFeedback = ({ view }: CustomerFeedbackProps) => {
	const { feedback, title } = view
	const feedbackCount = feedback.length

	const showCustomerFeedbackModal = useModal<CustomerFeedbackModalProps>(CustomerFeedbackModal)
	const showAllFeedbackModal = useCallback(
		() => showCustomerFeedbackModal({ feedback, title }),
		[feedback, showCustomerFeedbackModal, title],
	)

	return (
		<>
			<StyledText weight="semibold">
				<FormattedMessage {...customerFeedbackMessages.info} />
			</StyledText>

			{feedbackCount > 0 ? (
				<>
					<CustomerFeedbackList>
						{feedback.slice(0, 2).map((item, i) => (
							<CustomerFeedbackItem key={i} {...item} />
						))}
					</CustomerFeedbackList>

					<ShowAllFeedbackButton icon="none" underline onClick={showAllFeedbackModal}>
						<FormattedMessage
							{...customerFeedbackMessages.showAllFeedbackButton}
							values={{ count: feedbackCount }}
						/>
					</ShowAllFeedbackButton>
				</>
			) : (
				<NoFeedbackWrapper>
					<FormattedMessage {...customerFeedbackMessages.empty} />
				</NoFeedbackWrapper>
			)}
		</>
	)
}

const StyledText = styled(PText)`
	margin-bottom: ${spacingStaticLg};
`

const CustomerFeedbackList = styled.div`
	margin-top: ${spacingStaticLg};
	border-bottom: 1px solid ${colorContrastLow};
`

const ShowAllFeedbackButton = styled(PButtonPure)`
	margin-top: ${spacingStaticLg};
`

const NoFeedbackWrapper = styled(PText)`
	padding-top: ${spacingStaticLg};
	border-top: 1px solid ${colorContrastLow};
`
